import api from "../services/api";

const toNumber = (value) => {
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const normalizeEntry = (entry = {}) => {
  const usd = toNumber(entry.USDT_BOB || entry.usd || entry.USD);
  const brl = toNumber(entry.BRL || entry.brl);
  const bob = toNumber(entry.BOB || entry.bob);
  return {
    USD: toNumber(entry.USD || entry.usd || usd),
    BRL: brl,
    BOB: bob,
    USDT_BOB: usd || toNumber(entry.binanceUsd),
  };
};

export async function fetchRatesForDate(date) {
  const params = { data: date };
  try {
    const res = await api.get("/consultas-saldos/taxas", { params });
    const list = Array.isArray(res.data) ? res.data : [];
    const registro = list.find((item) => String(item?.DATA).slice(0, 10) === date) || list[0];
    if (registro) {
      return { ...normalizeEntry(registro), source: "database" };
    }
  } catch (_) {
    // ignora erro e tenta o fallback
  }
  try {
    const copia = await api.get("/consultas-saldos/taxas-copia", { params });
    const list = Array.isArray(copia.data) ? copia.data : [];
    const registro = list.find((item) => String(item?.DATA).slice(0, 10) === date) || list[0];
    if (registro) {
      return { ...normalizeEntry(registro), source: "copy" };
    }
  } catch (_) {
    // fallback alternativo
  }
  try {
    const ext = await api.get("/consultas-saldos/taxas/externas", { params });
    if (ext?.data) {
      return { ...normalizeEntry(ext.data), source: "external" };
    }
  } catch (_) {
    // retorna null se falhar
  }
  return null;
}

export const convertCurrency = (value = 0, currency = "USD", rates = {}) => {
  const amount = Number(value || 0) || 0;
  const usdRate = toNumber(rates.USDT_BOB || rates.USD);
  const brlRate = toNumber(rates.BRL);
  const bobRate = toNumber(rates.BOB);
  const result = { usd: 0, brl: 0, bob: 0 };
  if (amount === 0 || (!usdRate && !brlRate && !bobRate)) {
    return result;
  }
  if (currency === "USD") {
    result.usd = amount;
    result.brl = amount * brlRate;
    result.bob = amount * (usdRate || bobRate);
  } else if (currency === "BRL") {
    result.usd = brlRate ? amount / brlRate : 0;
    result.brl = amount;
    result.bob = amount * bobRate;
  } else if (currency === "BOB") {
    result.usd = usdRate ? amount / usdRate : 0;
    result.brl = bobRate ? amount / bobRate : 0;
    result.bob = amount;
  }
  return {
    usd: Number.isFinite(result.usd) ? result.usd : 0,
    brl: Number.isFinite(result.brl) ? result.brl : 0,
    bob: Number.isFinite(result.bob) ? result.bob : 0,
  };
};
